import { Outlet } from "react-router";
import * as Sentry from "@sentry/react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";

import LoadingOverlay from "./components/LoadingOverlay";
import { appTheme } from "./ui";

import "./index.css";

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={<p style={{ padding: 24 }}>Something went wrong. Our team has been notified.</p>}
    >
      <SnackbarProvider>
        <ThemeProvider theme={appTheme}>
          <CssBaseline />
          <LoadingOverlay />
          <Outlet />
        </ThemeProvider>
      </SnackbarProvider>
    </Sentry.ErrorBoundary>
  );
}
